import * as actionTypes from './type';

const INITIAL_STATE = {
    documents : [],
    isLoading : false,
    error : ""

}

export default function (state = INITIAL_STATE,action){

    switch(action.type){
        case actionTypes?.REQUEST_GET_ALL_DOCUMENTS: {
            return {
                ...state,
                isLoading : true,
            }
        }
        case actionTypes?.RECEIVED_ALL_DOCUMENTS: {
            return {
                ...state,
                isLoading : false,
                documents : action?.payload
            }
        }
        
        case actionTypes?.REQUEST_UPDATE_DOCUMENT: {
            return {
                ...state,
                isLoading : true,
            }
        }
        
        case actionTypes?.DOCUMENT_UPDATED_SUCCESSFULLY: {
            return {
                ...state,
                isLoading : false,
                documents : action?.payload
            }
        }
        case actionTypes?.REMOVE_ALL_DOCUMENTS:{
            return {
                ...state,
                isLoading : false,
                documents : action?.payload
            }
        }
        case actionTypes?.RECEIVED_ERROR:{
            return {
                ...state,
                error : action?.payload,
                isLoading : false
            }
        }
        default:
      return state; // ✅ Always return state
  }

}